import { DeviceType } from './types/onboarding.types.ts';
import { formatISO, parse } from 'date-fns';

export const checkIsFromLiliApp = (): boolean => {
  const origins = ['Lili', 'liliapp'] as const;
  let status = false;
  origins.map((origin) => {
    if (navigator.userAgent.toLowerCase().includes(origin.toLowerCase())) {
      status = true;
      return;
    }
  });
  return status;
};

export const checkDeviceType = () => {
  let type = DeviceType.UNKNOWN;
  if (!!navigator.userAgent && /iPad|iPhone|iPod|MacIntel/.test(navigator.userAgent)) {
    type = DeviceType.IOS;
  } else if (!!navigator.userAgent && /android|Android/i.test(navigator.userAgent)) {
    type = DeviceType.ANDROID;
  }
  return type;
};

export const getQueryParamsObject = () => {
  const search = window.location.search;
  const params = new URLSearchParams(search);
  const entries = params.entries();
  return Object.fromEntries(entries);
};

export const isObjectEmpty = (obj: Record<string, unknown>): boolean => {
  return Object.keys(obj).length === 0;
};

export const getCookiesList = () => {
  return document.cookie.split(';').map((c) => c.trim());
};
export const triggerBlurForAllFields = () => {
  const formElements = document.querySelectorAll('input, select, textarea');
  formElements.forEach((element) => {
    element.dispatchEvent(new Event('blur'));
  });
};

export const getParsedDateAsISO = (dateStr: string) => {
  const parsedDate = parse(dateStr, 'MM/dd/yyyy', new Date());
  return formatISO(parsedDate);
};

export const isEmbedded = () => window.self !== window.top;
